export interface LoginRequest {
  login: string;
  password: string;
}
export interface LoginData {
  token?: string;
  accountId?: string;
  accountType?: AccountType;
  email?: string;
  accountStatuses: Array<AccountStatus>;
  permissions: UserPermissions;
}
export interface LoginDataDTO {
  auth_token: string;
  user_state: UserStateDTO;
  user_permissions: { permissions: UserPermissions };
}

export interface UserStateDTO {
  accountId: {
    internalId: string;
  };
  email: string;
  accountType: AccountType;
  accountStatuses: Array<AccountStatus>;
  permissions: UserPermissions;
}

export enum AccountType {
  USER = "USER",
  MISSION_PARTNER = "MISSION_PARTNER",
  TALENT = "TALENT",
  ADMIN = "ADMIN",
  ADMIN_TALENT_MANAGER = "ADMIN_TALENT_MANAGER",
  ADMIN_SALES_MANAGER = "ADMIN_SALES_MANAGER",
}

export enum AccountStatus {
  REGISTERED = "REGISTERED",
  CONFIRMED = "CONFIRMED",
  VERIFIED = "VERIFIED",
  VACATIONING = "VACATIONING",
  REVIEWED = "REVIEWED",
  MARKED_FOR_DELETION = "MARKED_FOR_DELETION",
  SELF_SERVICE = "SELF_SERVICE",
  PASSIVE = "PASSIVE",
  PREMIUM = "PREMIUM",
  PUBLISHER = "PUBLISHER",
}

export interface UserPermissions {
  "hiring_dashboard.read": boolean;
  "hiring_dashboard.write": boolean;

  "talent_list.read": boolean;
  "talent_list.write": boolean;

  "mp_list.read": boolean;
  "mp_list.write": boolean;

  "jo_list.read": boolean;
  "jo_list.write": boolean;

  "com_list.read": boolean;
  "com_list.write": boolean;

  "hiring_list.read": boolean;
  "hiring_list.write": boolean;

  "assessment_list.read": boolean;
  "assessment_list.write": boolean;

  "invoice_list.read": boolean;
  "invoice_list.write": boolean;

  "admin_list.read": boolean;
  "admin_list.write": boolean;
}
